module.exports = __webpack_public_path__ + "7631c046b154b3781ed9fb090a8fafe3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1570559747074
// module id = 13
// module chunks = 0